<!--
 * @Author: your name
 * @Date: 2021-08-25 19:08:09
 * @LastEditTime: 2021-08-26 00:19:51
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \resources_map_front\src\components\UI\Table\index.vue
-->
<script>
import { Table } from 'ant-design-vue';
export default {
  props: {
    showTitle: {
      type: Boolean,
      default: true,
    },
    prefixCls: {
      type: String,
      default: 'ant-pro-table',
    },
  },
  data() {
    return {};
  },
  components: { Table },
  mounted() {},
  methods: {},
  render() {
    const props = {
      props: { ...this.$attrs },
      on: { ...this.$listeners },
      scopedSlots: { ...this.$scopedSlots },
    };
    if (props.props.pagination && props.props.pagination.total) {
      props.props.pagination.showTotal = (total) => `共计 ${total} 条`;
    }
    return (
      <div>
        <Table {...props} class={this.prefixCls}>
          {Object.keys(this.$slots).map((name) => (
            <template slot={name}>{this.$slots[name]}</template>
          ))}
        </Table>
      </div>
    );
  },
  renderError(h, err) {
    return h('pre', { style: { color: 'red' } }, err.stack);
  },
};
</script>
<style lang="less" scoped></style>
